import { render, staticRenderFns } from "./TemplateActionsMenu.vue?vue&type=template&id=7b2d2e22&scoped=true&lang=html"
import script from "./TemplateActionsMenu.vue?vue&type=script&lang=js"
export * from "./TemplateActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./TemplateActionsMenu.vue?vue&type=style&index=0&id=7b2d2e22&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d2e22",
  null
  
)

export default component.exports